/**
 * @template T
 * @typedef {Object} jQueryDeferred
 * @property {function(...function(T): void): jQueryPromise<T>} done - 成功時のコールバックを追加
 * @property {function(...function(*): void): jQueryPromise<T>} fail - 失敗時のコールバックを追加
 * @property {function(...function(): void): jQueryPromise<T>} always - 完了時（成功/失敗）のコールバックを追加
 * @property {function(function(T): void, function(*): void): jQueryPromise<T>} then - 成功時と失敗時のコールバックを追加
 * @property {function(): string} state - Deferredオブジェクトの現在の状態を取得
 * @property {function(...T): jQueryDeferred<T>} resolve - Deferredオブジェクトを成功状態に変更
 * @property {function(...*): jQueryDeferred<T>} reject - Deferredオブジェクトを失敗状態に変更
 */

/**
 * @template T
 * @typedef {Object} jQueryPromise
 * @property {function(...function(T): void): jQueryPromise<T>} done - 成功時のコールバックを追加
 * @property {function(...function(*): void): jQueryPromise<T>} fail - 失敗時のコールバックを追加
 * @property {function(...function(): void): jQueryPromise<T>} always - 完了時（成功/失敗）のコールバックを追加
 * @property {function(function(T): void, function(*): void): jQueryPromise<T>} then - 成功時と失敗時のコールバックを追加
 * @property {function(): string} state - Promiseオブジェクトの現在の状態を取得
 */

/**
 * 店舗関連の情報
 */

var Store = Store || {};


/**
 * お届け出来る日を配列で返却
 *
 * @param  {int} storeId
 * @return {jQueryDeferred<any>} Deferred
 */
Store.getSellableDays = function(storeId, productIds) {
  return $.ajax({
    url: '/service/store-sellable-days.json',
    method: 'GET',
    data: {
      storeId: storeId,
      productIds: productIds
    }
  });
};

/**
 * @typedef {Object} StoreSellableTimes
 * @property {string} start - HH:mm
 * @property {string} end - HH:mm
 */
/**
 * お届け出来る日時を配列で返却
 * @param {int}        storeId
 * @param {string|int} pref
 * @param {string|int} city
 * @param {string}     deliveryDate - お届け日 YYYY-MM-DD
 * @return {jQueryDeferred<StoreSellableTimes>} Deferred
 */
Store.getSellableTimes = function (storeId, pref, city, deliveryDate) {
  return $.ajax({
    url: '/service/store-sellable-times.json',
    method: 'GET',
    data: {
      storeId: storeId,
      pref: pref,
      city: city,
      deliveryDate: deliveryDate
    },
  });
};

/**
 * 店舗の価格帯を返却
 *
 * @param  int storeId
 * @return {jQueryDeferred<any>} Deferred
 */
Store.getPriceRange = function(storeId) {
  return $.ajax({
    url: '/service/price-range-of-store.json',
    method: 'GET',
    data: {
      id: storeId
    }
  });
};

/**
 * 新店舗情報を返却
 *
 * @return {jQueryDeferred<any>} Deferred
 */
Store.getNewOpen = function() {
  return  $.ajax({
    url: '/service/new-open-stores.json',
    method: 'GET'
  });
};

/**
 * @typedef {Object} PickupAvailableTimes
 * @property {string} start - HH:mm
 * @property {string} end - HH:mm
 */
/**
 * テイクアウト出来る日時を配列で返却
 * @param {int}        storeId
 * @param {string}     pickupDate - お届け日 YYYY-MM-DD
 * @return {jQueryDeferred<StoreSellableTimes>} Deferred
 */
Store.getPickupAvailableTimes = function (storeId, pickupDate) {
  return $.ajax({
    url: '/takeout/store-takeout-available-times.json',
    method: 'GET',
    data: {
      storeId: storeId,
      pickupDate: pickupDate
    },
  });
};
